import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { ProductDetailCommon } from './product-detail.common';
import { Injector } from '@angular/core';
@Component({
	selector: 'page-product-detail',
  	templateUrl: 'product-detail.html'
})

export class ProductDetailPage extends PageBase {
	public product:  string;
	public mySlideOptions = {
		initialSlide: 0,
		loop: true,
		pager: false
	};

	constructor(
		public injector: Injector,
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: ProductDetailCommon
	) {

		super(settings, events, nav, userData);
	}

	ngAfterViewInit() {
		this.common.commonMethod();
		this.product =  "pageView";
	}

	ionViewDidEnter() {
		
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/pages/product-detail/product-detail.ts